<script>
export default {
  name: "ViewDocuments",

  props: {
    showModal: Boolean,
    documents: Array,
    claim: Object,
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-10/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Claim Documents</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap p-2 bg-gray-300 mb-2">
          <div class="flex-1">
            <h5 class="font-medium text-sm">
              Patient: {{ claim.patientName }}
            </h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">MRN: {{ claim.patientID }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Claim No: {{ claim.claimNo }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Date: {{ (claim.trxDate || claim.date ) | dateFormat }}</h5>
          </div>
          <div class="flex-1">
            <h5 class="font-medium text-sm">Invoice No: {{ claim.invoiceNo }}</h5>
          </div>
        </div>
        <div class=" flex flex-col items-center w-full p-1 my-2" v-for="claimDoc in documents" :key="claimDoc.id">
            <h5 class="font-medium text-sm my-1">Name: {{claimDoc.docName}}</h5>
            <iframe
              v-if="claimDoc.contentType == `application/pdf`"
              :src="`data:application/pdf;base64,${claimDoc.document}`"
              height="800"
              width="1000"
            ></iframe>
            <img
              v-else
              :src="`data:application/image;base64,${claimDoc.document}`"
              :alt="claimDoc.docName"
            />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
